import {
  getPostCover as _getPostCover,
  getPostVideoEmbedCover as _getPostVideoEmbedCover,
} from '@wix/communities-universal/dist/src/services/get-post-cover';
import { resizeThumbnail } from './thumbnail-utils';
import { getVideoUrl } from './video-utils';

export { getPostImageCover } from '@wix/communities-universal/dist/src/services/get-post-cover';

const helpers = {
  resizeThumbnail,
  getVideoUrl,
};

export const getPostCover = (post) => {
  if (post.media) {
    return {
      imageMetadata: {
        url: post?.media?.wixMedia?.image?.url,
        height: post?.media?.wixMedia?.image?.height,
        width: post?.media?.wixMedia?.image?.width,
      },
      shouldRender: post?.media?.displayed,
    };
  }

  return _getPostCover(post, helpers);
};
export const getPostVideoEmbedCover = (post) => _getPostVideoEmbedCover(post, helpers);
